/* eslint-disable react/prop-types */
import React, { forwardRef } from 'react';
import { Path } from 'react-konva';

// eslint-disable-next-line react/prop-types, react/display-name
const Triangle = forwardRef((props, ref) => {
  // const shapeRef = React.useRef();
  const pointsLeft = [0, 0, props.width, props.height / 2, 0, props.height];
  const pointsRight = [0, props.height / 2, props.width, 0, props.width, props.height];
  let points = [];
  // eslint-disable-next-line react/prop-types
  const type = props.type;
  if (type === 'triangleLeft') {
    points = pointsLeft;
  } else if (type === 'triangleRight') {
    points = pointsRight;
  }

  // function handleClick (e) {
  //   props.onSelect();
  //   props.onClick();
  // };

  //   useEffect(() => {
  //     if (props.isSelected) {
  //     // we need to attach transformer manually
  //       trRef.current.nodes([shapeRef.current]);
  //       trRef.current.getLayer().batchDraw();
  //     // console.log('selected shape: ' + this.state.id);
  //     };
  //   }, [props.isSelected]);

  return (
    <React.Fragment>
    <Path
      ref={ref}
      data={`M${points[0]},${points[1]} L${points[2]},${points[3]} L${points[4]},${points[5]} Z`}
      // onClick={handleClick}
      {...props}
    />
    </React.Fragment>
  );
});
export default React.memo(Triangle);
